import { Box, Grid, Paper } from '@mui/material';
import StyledInputField from '../../../Components/Custom/StyledInputField';
import MuiTypographyMandatory from '../../../Components/Custom/MuiTypographyMandatory';
import { VM_Colors } from '../../../Styles/VMStyles';
import { formatTierAmount } from '../../../Util/subscriptionTierHelper';

function PaymentsSection({ state, setState, countryCode }) {
  const handleAdvanceChange = (e) => {
    const value = e.target.value;

    // prevent negative values
    if (Number(value) < 0) return;

    setState(prev => ({
      ...prev,
      advance_amount: value,
    }));
  };

  return (
    <Box>
      <MuiTypographyMandatory
        variant="h3"
        required
        label="Payments"
        sx={{fontWeight: 700}}
      />

      <Paper sx={{ mt: 1, p: 2, borderRadius: 2 }}>
        <Box sx={{ p: 2, backgroundColor: VM_Colors.paper_bg, borderRadius: 2 }}>
          <Grid container spacing={2}>
            {/* Advance Amount */}
            <Grid item xs={12} sm={6}>
              <StyledInputField
                label="Enter Advance Amount"
                type="number"
                value={state.advance_amount}
                onChange={handleAdvanceChange}
                inputProps={{
                  min: 0,
                  onWheel: (e) => e.target.blur(), // prevent scroll change
                }}
                startAdornment={countryCode?.currency_symbol}
              />
            </Grid>

            {/* Pending Amount (read-only) */}
            <Grid item xs={12} sm={6}>
              <StyledInputField
                label="Pending Amount"
                value={formatTierAmount(state.pending_amount, countryCode?.currency_symbol)}
                disabled
                startAdornment={countryCode?.currency_symbol}
              />
            </Grid>
          </Grid>
        </Box>
      </Paper>
    </Box>
  );
}

export default PaymentsSection;